import { render, staticRenderFns } from "./LegendeDeco.vue?vue&type=template&id=2f4dca3d&"
import script from "./LegendeDeco.vue?vue&type=script&lang=js&"
export * from "./LegendeDeco.vue?vue&type=script&lang=js&"
import style0 from "./LegendeDeco.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../dates/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports